import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const querytableColumnDateProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],

  // Date
  format: String,
  sourceFormat: String,
})

export type QuerytableColumnDateProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnDateProps>>>

export default defineComponent({
  name: 'OQuerytableColumnDate',
  inheritAttrs: false,
  props: querytableColumnDateProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
